import React from "react";
import FormFooterPartner from "./FormFooterPartner";
import SignupFormPartner from "./SignupFormPartner";

function SignupPagePartner() {
  // localStorage.clear("");
  return (
    <>
      {/* <title>Log In - Bajaj Finserv</title> */}
      {/* <div className="login-page">
        <div className="login-content h-100">
          <div className="container h-100">
            <div className="h-100">
              <div className="ipad-bottom m-auto"> */}
                <SignupFormPartner />
                {/* <FormFooterPartner /> */}
              {/* </div>
            </div>
          </div>
        </div>
      </div> */}
    </>
  );
}

export default SignupPagePartner;
